import { render, staticRenderFns } from "./CardFinanceSummary.vue?vue&type=template&id=064e8421&scoped=true&"
import script from "./CardFinanceSummary.vue?vue&type=script&lang=js&"
export * from "./CardFinanceSummary.vue?vue&type=script&lang=js&"
import style0 from "./CardFinanceSummary.vue?vue&type=style&index=0&id=064e8421&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064e8421",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAvatar,VCard,VCardActions,VCardSubtitle,VCardText,VCardTitle,VChip,VIcon,VImg,VProgressLinear})
